import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { RootState } from '../store';
import { getProfileProperties } from '../../api/configsApi';
import { AxiosResponse } from 'axios';

export interface ConfigsState {
  webUploaderUrl?: string;
  environmentName?: string;
}

const initialState: ConfigsState = {};

export const loadProfileProperties = createAsyncThunk('/config/environment', async (payload, { rejectWithValue }) => {
  try {
    return await getProfileProperties();
  } catch (err: any) {
    return rejectWithValue((err.response as AxiosResponse).data?.message || err.message);
  }
});

export const configsSlice = createSlice({
  name: 'configs',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(loadProfileProperties.fulfilled, (state, action) => {
      state.environmentName = action.payload.environment;
      state.webUploaderUrl = action.payload.webLoaderUrl;
    });
  },
});

// selectors

export const selectWebUploaderLink = (state: RootState) => state.configs.webUploaderUrl;

export const selectEnvironmentName = (state: RootState) => state.configs.environmentName;

export default configsSlice.reducer;
